import {
  createSerialNumberValidator,
  isValidQRCodeWithSerialNumber,
} from '@/shared/utils/solshare-serial';

/**
 * When `true`, commissioning entry points (manual serial + QR) accept MK1 formats (`3P_35A_XXXX`, etc.).
 * Flip to `true` when commissioning supports MK1 devices.
 */
export const COMMISSIONING_ALLOWS_MK1_SERIAL = false;

/** MK2-only until {@link COMMISSIONING_ALLOWS_MK1_SERIAL} is enabled. */
export const commissioningSerialNumberValidator = createSerialNumberValidator({
  allowMk1: COMMISSIONING_ALLOWS_MK1_SERIAL,
});

export function isValidCommissioningQRCode(qrcodeContent: string): boolean {
  return isValidQRCodeWithSerialNumber(qrcodeContent, {
    allowMk1: COMMISSIONING_ALLOWS_MK1_SERIAL,
  });
}
